<template>
  <v-container fluid flat row class="pb-4 mb-4 bookings main">
    <v-stepper non-linear alt-labels flat v-model="active">
      <v-stepper-header class="mb-0 stepper_menu" v-if="complete === false">
        <template v-for="(f, i) in form_steps">
          <v-stepper-step
            @click="goToStepHeader(getFormIndexByPath(f.path))"
            v-if="f.active === true"
            :key="i"
            :step="getStepNumberByPath(f.path)"
            :complete="testCompleteStep(f.path) && testEditableStep(f.path)"
            :complete-icon="f.meta.icon"
            :editable="testEditableStep(f.path)"
            :edit-icon="f.meta.icon"
            error-icon="error"
            :class="{ error: testStepError(f.path), 'pt-4': true, 'pb-0': true, 'mx-0': true }"
          >
            {{ f.name }}
            <div class="error hidden">
              {{ f.meta.status.errorText }}
            </div>
          </v-stepper-step>
        </template>
      </v-stepper-header>
      <v-stepper-items>
        <router-view class="page pb-2"></router-view>
      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>

<script>
import store from "../store";
import BookingFormMixin from "@/mixins/BookingFormMixin.js";
import Shared from "@/mixins/Shared.js";
import { EventBus } from "../services/EventBus.js";
import { createHelpers } from "vuex-map-fields";
const { mapFields } = createHelpers({
  getterType: "getField",
  mutationType: "updateField"
});

export default {
  name: "BookingsView",
  store: store,
  mixins: [BookingFormMixin, Shared],
  computed: {
    ...mapFields(["active", "form", "form_fields.ret_date"]),
    form_steps() {
      return this.getFormSteps();
    }
  },
  mounted() {
    this.startTimer();
    let formTimeoutInterval = setInterval(function() {
      EventBus.$emit("testFormTimeout", {});
    }, 1000);
    window.addEventListener('beforeunload', function(event) {
      console.log("UNLOAD EVENT");
    });
  },
  created() {
    // console.log(process.env.VUE_APP_TITLE);
    if (this.loading !== false) {
      console.log("unfreeze loading state")
      store.commit("setLoading", false);
    }
    EventBus.$on('testFormTimeout', () => {
      this.testFormTimeout(true);
    });
    EventBus.$on('editBookingDetailsLoaded', () => {
      store.commit("setFormComplete", false);
      // this.startTimer();
      this.validateSteps();
      this.setNextStepQuery(0);
    });
    EventBus.$on('userLogin', () => {

    });
    EventBus.$on('userCreated', () => {
			this.createAccountRedir();
    });

    if( this.$route.fullPath.indexOf('/booking/departing') === 0 )
    {
      // App loaded on departing tab
      this.resetFormExceptDepart();
    }
		else if( this.getDepartFlight() == null )
		{
			// If not on the departing select tab and there is no
			// departing flight selected, reset everything
			this.resetForm();
		}

    // console.log( 'Departing Path Index:', this.$route.fullPath.indexOf('/booking/departing/') );
    this.restoreStep(this.active);
    if (this.$route.query.way_type !== undefined) {
      this.getRouteQuery(this.$route.query);
      this.startTimer();
    } else if (
      this.$route.query.edit !== undefined
    ) {
      console.log("---- EDIT BOOKING ----", this.$route.query);
      this.startTimer();
      this.getEditBookingDetails(this.$route.query);
    }

    this.isMobileDevice();
    window.addEventListener("resize", () => {
      this.isMobileDevice();
      // this.startTimer();
    });
    document.onkeydown = this.keydown;
  }
};
</script>

<style lang="scss">
@import "@/styles/theme.scss";
</style>
